"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorage = exports.useSessionStorage = void 0;
const react_1 = require("react");
const useSharedState_1 = __importDefault(require("./useSharedState"));
/**
 * Build a hook to store/extract stuff from session or local storage
 */
const buildHook = (keyPrefix, storage) => {
    const SHARED_STATE_PREFIX = `__${keyPrefix}:`;
    /**
     * Store and retrieve values from local/session storage. The same key
     * may be used across components, and subscriptions will keep the cached local
     * state in sync.
     *
     * @param {string} key the key for dereferencing the data in storage; may
     *                     not change across renders
     * @param {*} initialValue the initial value if the item doesn't yet exist
     *                         in storage
     * @returns {[*, Function]} the current value and a function for updating it
     *
     */
    const useStorage = (key, initialValue) => {
        const [value, setValue] = useSharedState_1.default(`${SHARED_STATE_PREFIX}${key}`, () => {
            const cached = storage.getItem(key);
            if (cached && cached != 'undefined') {
                return JSON.parse(cached);
            }
            else {
                return initialValue;
            }
        });
        return [
            value,
            react_1.useCallback((v, persist = true) => {
                setValue(v);
                if (persist) {
                    storage.setItem(key, JSON.stringify(v));
                }
            }, [key, setValue]),
        ];
    };
    useStorage.reset = () => {
        useSharedState_1.default.reset(SHARED_STATE_PREFIX);
        storage.clear();
    };
    return useStorage;
};
exports.useSessionStorage = buildHook('sessionStorage', sessionStorage);
exports.useLocalStorage = buildHook('localStorage', localStorage);
//# sourceMappingURL=useStorage.js.map